module.exports = __webpack_public_path__ + "static/media/Gear.svg";